import React, { Component } from "react";
import styles from './styles.css'

class Button extends Component {
  render() {
    return (
      <a href={this.props.href} target={this.props.target ? this.props.target : '_self'} className="button">{this.props.children}</a>
    );
  }
}

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button/index.js